import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { TableController } from "../../../components/Constant";
import { useTranslation } from "react-i18next";

import { VERSION_LIST, VERSION_UPDATE } from "../../../repository/version_repo";

const useVersion = () => {
  const { t } = useTranslation();

  const [versionList, setVersionList] = useState([]);
  const [controller, setController] = useState(TableController);
  const [totalCount, setTotalCount] = useState(0);
  const [loader, setLoader] = useState(false);

  const [anchorEl, setAnchorEl] = useState({ element: null, index: null });

  const [formData, setFormData] = useState({
    type: "",
    project: "",
    version: "",
    _id: "",
  });

  const [openModal, setOpenModal] = useState({
    edit: false,
    data: null,
  });

  const openMenu = Boolean(anchorEl.element);

  const handleClickMenu = (event, index) => {
    setAnchorEl({ element: event.currentTarget, index });
  };

  // Open modal via handleOpenModal("edit")
  const handleCloseMenu = (rowData) => {
    setAnchorEl({ element: null, index: null });

    // Fill data before opening modal
    setFormData({
      type: rowData.type,
      project: rowData.project,
      version: rowData.version,
      _id: rowData._id,
    });

    handleOpenModal("edit");
  };

  const handleOpenModal = (type) => {
    setOpenModal((prev) => ({
      ...prev,
      [type]: true,
    }));
  };

  const handleClosedModal = (type) => {
    setOpenModal((prev) => ({
      ...prev,
      [type]: false,
    }));
  };

  const TableHeadData = [
    { label: "#" },
    { label:  `${t("tableTitle.project")}` },
    { label:  `${t("tableTitle.device")}` },
    { label: `${t("sideBar.version")}` },
    { label: `${t("tableTitle.action")}` },
  ];

  useEffect(() => {
    getVersionList();
  }, []);

  const getVersionList = async () => {
    try {
      setLoader(true);
      let response = await VERSION_LIST();
      setVersionList(response?.data || []);
    } catch (error) {
      setVersionList([]);
    }
    setLoader(false);
  };

  const versionUpdate = async () => {
    try {
      let payload = {
        _id: formData._id,
        type: formData.type,
        project: formData.project,
        version: formData.version,
      };

      setLoader(true);
      let response = await VERSION_UPDATE(payload);

      if (response?.code === 200) {
        toast.success(response.message);
        handleClosedModal("edit");
        getVersionList();
      }
    } catch (error) {
      toast.error("Failed to update version");
    }

    setLoader(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handlePagination = (obj) => setController(obj);

  return {
    data: {
      controller,
      totalCount,
      loader,
      anchorEl,
      openModal,
      versionList,
      openMenu,
      formData,
    },
    method: {
      handlePagination,
      handleClosedModal,
      handleOpenModal,
      TableHeadData,
      setAnchorEl,
      handleCloseMenu,
      handleClickMenu,
      versionUpdate,
      handleChange,
    },
  };
};

export default useVersion;
